import * as types from '../services/CommunicationActionType';

function communicationReducer(state = {}, action) {
    switch (action.type) {
        case types.GET_COMMUNICATIONS_REQUEST:
            return { ...state, communicationLoading: true };
        case types.GET_COMMUNICATIONS_SUCCESS:
            return { ...state, communicationLoading: false, communications: action.payload };
        case types.GET_COMMUNICATIONS_FAILURE:
            return { ...state, communicationLoading: false };

        case types.GET_NOTIFICATIONS_REQUEST:
            return { ...state, notificationLoading: true };
        case types.GET_NOTIFICATIONS_SUCCESS:
            return { ...state, notificationLoading: false, notificationData: action.payload };
        case types.GET_NOTIFICATIONS_FAILURE:
            return { ...state, notificationLoading: false, notificationData: null };

        case types.GET_COMMUNICATION_NOTIFICATION_REQUEST:
            return { ...state, communicationNotificationLoading: true, communicationNotificationError: null };
        case types.GET_COMMUNICATION_NOTIFICATION_SUCCESS:
            return { ...state, communicationNotificationLoading: false, communicationNotifications: action.payload, communicationNotificationError: null };
        case types.GET_COMMUNICATION_NOTIFICATION_FAILURE:
            return { ...state, communicationNotificationLoading: false, communicationNotificationError: action.payload };

        case types.GET_ALL_OTHER_COMMUNICATIONS_REQUEST:
            return { ...state, communicationNotificationLoading: true };
        case types.GET_ALL_OTHER_COMMUNICATIONS_SUCCESS:
            return { ...state, communicationNotificationLoading: false, otherCommunicationsData: action.payload };
        case types.GET_ALL_OTHER_COMMUNICATIONS_FAILURE:
            return { ...state, communicationNotificationLoading: false };

        default:
            return state;
    }
}
export default communicationReducer;